import { Control, ControlType } from './control';

export const AhvRegExp = new RegExp(
  /[7][5][6][.][\d]{4}[.][\d]{4}[.][\d]{2}$/
);

export class AhvControl extends Control<string> {
  constructor(name: string, placeholder: string) {
    super(name, placeholder, ControlType.ahv, '');
  }

  isValid(): boolean {
    return this.required ? AhvRegExp.test(this.value as string) : true;
  }
}
